import React from 'react';
import { useUserType, VIEW_MODES } from 'utils/userTypeContext';
import { useTranslation } from 'utils/i18n';
import { Icons } from 'components/Icons';
import './UserTypeSelectionModal.css';

const UserTypeSelectionModal = ({ onSelect }) => {
  const { t } = useTranslation();
  const { setViewMode } = useUserType();

  const handleSelection = (viewMode) => {
    // Update viewMode context
    setViewMode(viewMode);

    // Save to localStorage for future visits
    localStorage.setItem('viewMode', viewMode);
    localStorage.setItem('userTypeSelectionCompleted', 'true');

    // Call onSelect callback if provided
    if (onSelect) {
      onSelect(viewMode);
    }
  };

  return (
    <div className="user-type-selection-modal-overlay">
      <div className="user-type-selection-modal">
        <div className="user-type-selection-modal-content" style={{ color: '#1a1a1a', background: '#ffffff', textShadow: 'none' }}>
          <div className="user-type-selection-header">
            <h2 className="user-type-selection-title" style={{ color: '#1a1a1a', textShadow: 'none' }}>
              {t('userTypeSelectionModal.title', 'How would you like to use B-esper?')}
            </h2>
            <p className="user-type-selection-subtitle" style={{ color: '#475569', textShadow: 'none' }}>
              {t('userTypeSelectionModal.subtitle', 'Choose the experience that best fits your needs')}
            </p>
          </div>

          <div className="user-type-selection-cards">
            <button
              className="user-type-card customer-card"
              onClick={() => handleSelection(VIEW_MODES.NORMAL)}
              aria-label={t('userTypeSelectionModal.customer.ariaLabel', 'Select customer view - buy and use products')}
              style={{ background: '#ffffff', color: '#1a1a1a', textShadow: 'none' }}
            >
              <div className="user-type-card-icon" style={{ color: '#5897de' }}>
                <Icons.User size={32} />
              </div>
              <div style={{ flex: 1, minWidth: 0, textShadow: 'none' }}>
                <h3 className="user-type-card-title" style={{ color: '#1a1a1a', textShadow: 'none' }}>
                  {t('userTypeSelectionModal.customer.title', "I'm here to buy and use products")}
                </h3>
                <p className="user-type-card-description" style={{ color: '#475569', textShadow: 'none' }}>
                  {t('userTypeSelectionModal.customer.description', 'Discover and subscribe to enterprise SaaS solutions. Browse our marketplace and deploy products instantly.')}
                </p>
              </div>
              <div className="user-type-card-arrow" style={{ color: '#5897de' }}>
                <Icons.ChevronRight size={18} />
              </div>
            </button>

            <button
              className="user-type-card technical-card"
              onClick={() => handleSelection(VIEW_MODES.TECHNICAL)}
              aria-label={t('userTypeSelectionModal.technical.ariaLabel', 'Select technical view - sell and host products')}
              style={{ background: '#ffffff', color: '#1a1a1a', textShadow: 'none' }}
            >
              <div className="user-type-card-icon" style={{ color: '#5897de' }}>
                <Icons.Business size={32} />
              </div>
              <div style={{ flex: 1, minWidth: 0, textShadow: 'none' }}>
                <h3 className="user-type-card-title" style={{ color: '#1a1a1a', textShadow: 'none' }}>
                  {t('userTypeSelectionModal.technical.title', "I'm here to sell and host products")}
                </h3>
                <p className="user-type-card-description" style={{ color: '#475569', textShadow: 'none' }}>
                  {t('userTypeSelectionModal.technical.description', 'Resell products, bundle services, or host your own SaaS solutions. Build your business on our platform.')}
                </p>
              </div>
              <div className="user-type-card-arrow" style={{ color: '#5897de' }}>
                <Icons.ChevronRight size={18} />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTypeSelectionModal;

